import cloneDeep from 'lodash/cloneDeep'
import { JobOfferStages } from '@/constants/job/jobOfferStages'
import { convertToLocal } from '@/utils/date'

export default class JobApplicationOffer {
  id: number
  createdAt: Date
  deadline: number
  budget: string
  stage: JobOfferStages
  freelancerId: number
  customerId: number
  freelancerWallet: string

  constructor(data: Partial<JobApplicationOffer>) {
    Object.assign(this, cloneDeep(data))
  }

  static fromServer(data: LX.JobApplicationOffer) {
    return new JobApplicationOffer({
      id: data.id,
      createdAt: new Date(convertToLocal(data.created_at)),
      deadline: data.deadline,
      budget: data.budget,
      stage: data.stage,
      freelancerId: data.freelancer_id,
      customerId: data.customer_id,
      freelancerWallet: data.freelancer_wallet,
    })
  }

  get deadlineInDays() {
    return (this.deadline || 0) / 86400
  }
}
